<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12" vs-sm="12">
      <vs-card class="ha-groups-panel">
        <HAGroupList></HAGroupList>
      </vs-card>
    </vs-col>
  </vs-row>
</template>

<script>
import HAGroupList from "./ha_group/HAGroupList";
export default {
  name: "HAGroups",
  components: {
    HAGroupList
  }
}
</script>

<style lang="scss" scoped>
::v-deep.ha-groups-panel {
  padding: 15px 20px 30px 20px;

  .vs-card--header {
    padding: 0;
    margin: 0;
    font-size: 14px;
    opacity: 0.7;
    font-weight: 300;
  }

  .vs-card--content {
    padding: 0;
    margin: 15px 0 0 0;
  }
}

</style>
